export default {"src":"/_next/static/media/shield.6202730e.svg","height":132,"width":111,"blurWidth":0,"blurHeight":0};